// extracted by mini-css-extract-plugin
module.exports = {"container":"iv","image":"iw","title":"ix","date":"iy"};